module.exports = __webpack_public_path__ + "static/media/subOutlook4.78603ed4.png";